import { combineReducers } from 'redux';
import * as types from './constants';
const merge = require('deepmerge');

const initialState = {
    dialogs: [],
};

export default combineReducers({
    dialogs(state = initialState.dialogs, action) {
        switch (action.type) {
            case types.UPDATE_CHAT:
                return { ...state, chat: action };
            case types.GET_ROOMS_LIST_SUCCESS:
                return [
                    ...action.data
                ];
            case types.MARK_ROOM_AS_READ_SUCCESS:
                let { data: {id} } = action;
                return state.map((item, index) => {
                    if (id !== item.id) {
                        return item;
                    }

                    return {
                        ...item,
                        unread_count: 0,
                    }
                });
            case 'ws:ChatBots/NewMessageNotification':
                let { data: { message } } = action;
                const dialogs = state.some(dialog => dialog.id === message.room.id) ? state: [{...message.room, messages: []}, ...state];
                let { data: { message: {room, ...messagePayload} } } = action;
                let activeDialog = dialogs.find(dialog => dialog.id === message.room.id);
                if (activeDialog) {
                    activeDialog.messages.push(messagePayload);
                    activeDialog.unread_count = message.room.unread_count;
                    activeDialog.visits = message.room.visits;
                    if (dialogs.indexOf(activeDialog) > 0) {
                        dialogs.splice(dialogs.indexOf(activeDialog), 1);
                        dialogs.unshift(activeDialog);
                    }
                }
                return [...dialogs];
            case types.SET_MANAGER_SUCCESS:
                state.find(dialog => dialog.id === action.data.id).manager_id = action.data.manager_id;
                return state;
            case types.ARCHIVED_CHAT_SUCCESS:
                let {data} = action;
                return state.map(item => {
                    if (data.id !== item.id) {
                        return item;
                    }

                    return {
                        ...item,
                        is_archived: 1,
                    }
                });
            default:
                return state;
        }
    },
});
